import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NewLineKind } from 'typescript';

@Directive({
  selector: '[formControlName][appDigitMask]',
})
export class DigitMaskDirective {

  constructor(public ngControl: NgControl) { }

  @Input('appDigitMask') n:number;

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }

  @HostListener('keydown.backspace', ['$event'])
//   keydownBackspace(event) {
//     this.onInputChange(event.target.value, true);
//     event.preventDefault();
//     event.stopPropagation();
//   }

  ngAfterContentInit() {
    var value = this.ngControl.control.value;
    // this.onInputChange(value, false);
  }

  onInputChange(event) {
    let newVal = event.replace(/\D/g, '');
    if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length > this.n) {
          newVal = newVal.substring(0, this.n);
      }
    this.ngControl.valueAccessor.writeValue(newVal);
    this.ngControl.control.setValue(newVal, {emitModelToViewChange: false})
    // this.ngControl.control.updateValueAndValidity(); {emitEvent: false}
  }
}
